import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';

@Component({
  selector: 'app-list-group',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.data-expanded]': 'expanded()',
  },
  template: `
    <button
      class="list-group__header"
      type="button"
      (click)="toggle()"
      [attr.aria-expanded]="expanded()"
    >
      <span class="list-group__label">{{ label() }}</span>
      @if (count()) {
        <span class="list-group__count">{{ count() }}</span>
      }
      <span class="material-icons list-group__chevron" translate="no">chevron_right</span>
    </button>
    <div class="list-group__body" [class.list-group__body--open]="expanded()">
      <div class="list-group__items" role="group">
        <ng-content />
      </div>
    </div>
  `,
  styleUrl: './list-group.component.scss',
})
export class ListGroupComponent {
  label = input.required<string>();
  count = input<number | null>(null);
  expanded = model(true);

  toggle(): void {
    this.expanded.update(v => !v);
  }
}
